import styled from "@emotion/styled"

const ContentAbout = styled('div')(() => ({
    height: 'auto',
    position:'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}))

export default ContentAbout